import {
  BackStyle,
  type CustomerPreferences,
  EarStyle,
  HairLength,
  Neckline,
  Parting,
} from '@drycut/graphql';
import { Para, Stack, ValueOrDash } from '@drycut/ui-components';

import PreferenceCheck from './PreferenceCheck';
import PreferenceRow from './PreferenceRow';
import PreferencesTable from './PreferencesTable';

const EarStyles: Record<EarStyle, string> = {
  [EarStyle.Uncovered]: 'frei',
  [EarStyle.Covered]: 'bedeckt',
  [EarStyle.NotDefined]: '',
};

const NeckStyles: Record<Neckline, string> = {
  [Neckline.Tapered]: 'auslaufend',
  [Neckline.Straight]: 'gerade',
  [Neckline.NotDefined]: '',
};

const BackStyles: Record<BackStyle, string> = {
  [BackStyle.Straight]: 'gerade',
  [BackStyle.Rounded]: 'abgerundet',
  [BackStyle.NotDefined]: '',
};

const PartingStyles: Record<Parting, string> = {
  [Parting.Left]: 'links',
  [Parting.Middle]: 'Mitte',
  [Parting.Right]: 'rechts',
  [Parting.NotDefined]: '',
};

type Props = {
  preferences: CustomerPreferences;
};

export default function PreferencesList({ preferences }: Props) {
  const {
    hairLength,
    lengthSides,
    lengthTop,
    cutEyebrows,
    layers,
    parting,
    backStyle,
    ears,
    neckline,
  } = preferences;

  return (
    <Stack>
      <Para weight="bold" size="sm" className="text-zinc-700">
        Präferenzen — {hairLength === HairLength.Short ? 'Kurzhaar' : 'Langhaar'}
      </Para>

      <Stack direction="row" className="my-2 py-2 border-y border-y-zinc-200 gap-8 items-start">
        <PreferencesTable>
          {hairLength === HairLength.Short && (
            <>
              <PreferenceRow label="Länge seite">
                <ValueOrDash value={lengthSides} suffix=" mm" />
              </PreferenceRow>

              <PreferenceRow label="Länge oben">
                <ValueOrDash value={lengthTop} suffix=" mm" />
              </PreferenceRow>

              <PreferenceRow label="Ohren">
                <ValueOrDash value={ears && EarStyles[ears]} />
              </PreferenceRow>

              <PreferenceRow label="Nacken" noPadding>
                <ValueOrDash value={neckline && NeckStyles[neckline]} />
              </PreferenceRow>
            </>
          )}

          {hairLength === HairLength.Long && (
            <>
              <PreferenceRow label="Haare gestuft">
                <PreferenceCheck value={layers} />
              </PreferenceRow>

              <PreferenceRow label="Haare hinten">
                <ValueOrDash value={backStyle && BackStyles[backStyle]} />
              </PreferenceRow>
            </>
          )}
        </PreferencesTable>

        <PreferencesTable>
          <PreferenceRow label="Augenbraunen kürzen">
            <PreferenceCheck value={cutEyebrows} />
          </PreferenceRow>

          <PreferenceRow label="Scheitel">
            <ValueOrDash value={parting && PartingStyles[parting]} />
          </PreferenceRow>
        </PreferencesTable>
      </Stack>
    </Stack>
  );
}
